const globalVariable = {
    animationDurationFromGlobal: 200,
}

export default globalVariable



